module.exports = __webpack_public_path__ + "media/images/icons/outlined/laptop-a654b1ea77c66386c31032fbae1976e9.svg";